import c from "../common";

export default {
  titletext: c.BBS_title.chn,

  selectshop: "選取商店：",
  Logout: c.Logout.chn,

  //Slider
  Homepage: c.homepage.chn,
  Detail: "商戶詳情",
  StaffMgt: "員工管理",
  DataCenter: "數據中心",
  Voucher_And_Discount: c.voucher.chn + " & " + c.discount.chn,
  ComingSoon: c.ComingSoon.chn,
  Event: "活動",
  EventDetail: "活動詳情",
  Partner: "夥伴",
  PaymentGateway: "付款渠道",
  Takeaway: c.takeaway.chn,
  language: c.language.chn,
  Event: c.event.chn,
  EventDetail: "活動詳情",
  Estamp: c.estamp.chn,
  RewardEvent: c.rewardEvent.chn,
  AdCarousel: "廣告",
  PushNotification: "推送通知",

  Homepage2: c.homepage.chn,
};
